import { FC, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { getContract } from '../../../api/miContracts'
import { getInquiries } from '../../../api/miInquiries'
import {
  Contract,
  ContractStatusMap,
  ProtectionTypeMap,
  ServiceTypeMap,
  makeAddress,
  makePostalNumber,
} from '../../../models/contractsModel'
import { InquiriesResponse } from '../../../models/inquiriesModel'
import { ContractsPath } from '../../../routes/path'
import { idTokenState, requestState } from '../../../states/atoms'
import { fmtDate } from '../../../util/date'
import { ListInquirySection } from './inquiry'

export const ContractDetailsSection: FC = () => {
  const { id } = useParams<{ id: string }>()
  const { idToken, isTokenRequested } = useRecoilValue(idTokenState)
  const [contract, setContract] = useState<Contract>()
  const [inquiries, setInquiries] = useState<InquiriesResponse>()
  const [collapsedInquiry, setCollapsedInquiry] = useState<boolean>(true)
  const [requestStatus, setRequestStatus] = useState<boolean>(false)
  const [collapsedDetail, setCollapsedDetail] = useState(true)
  const setRequestState = useSetRecoilState(requestState)

  const onClickCollapsed = () => {
    setCollapsedInquiry(false)
  }

  const onClickCollapsedDetailMore = () => {
    setCollapsedDetail(false)
  }

  const onClickCollapsedDetailLess = () => {
    setCollapsedDetail(true)
  }

  useEffect(() => {
    const init = async () => {
      if (!idToken) return

      try {
        const data = await getContract(id, idToken)
        setContract(data?.contract)
        setRequestStatus(true)
      } catch (error) {
        setRequestStatus(true)
        setRequestState({
          errorMessage: `詳細情報が取得できませんでした。\n時間を置いて再度お試しください。`,
        })

        setTimeout(() => {
          location.href = ContractsPath
        }, 1.5 * 1000)
      }
    }
    init()
  }, [idToken])

  useEffect(() => {
    const init = async () => {
      if (!idToken) return

      try {
        const data = await getInquiries(id, idToken)
        setInquiries(data)
      } catch (error) {
        console.log(error)
      }
    }
    init()
  }, [idToken])

  return (
    <div className="detailsBody containerBase">
      {!contract || !requestStatus ? (
        <Container></Container>
      ) : (
        <Container>
          <Row className="box">
            <Col xs={12}>
              <Row>
                <Col xs={12}>
                  <div className="section">{contract.product.title}</div>
                </Col>
              </Row>
              <Row className="panel">
                <Col xs={12} sm={5} className="image">
                  <img
                    src={contract.product.imageUrl}
                    alt="No Image"
                    onError={(e: any) => {
                      e.target.onError = null // 代替画像が取得できない場合の無限ループを回避
                      e.target.src = '/images/no_image.png'
                    }}
                  />
                </Col>
                <Col xs={12} sm={7} className="details">
                  <Row>
                    <Col xs={12} sm={6} className="cell">
                      <div className="label">保証番号</div>
                      <div className="detailContent">
                        <div className="text center">{contract.id}</div>
                      </div>
                    </Col>
                    <Col xs={12} sm={6} className="cell">
                      <div className="label">保証プラン</div>
                      <div className="detailContent">
                        <div className="text center">{contract.plan.title}</div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6} className="cell">
                      <div className="label">サービスタイプ</div>
                      <div className="detailContent">
                        <div className="text center">{ServiceTypeMap[contract.plan.serviceType]}</div>
                      </div>
                    </Col>
                    <Col xs={12} sm={6} className="cell">
                      <div className="label">保証タイプ</div>
                      <div className="detailContent">
                        <div className="text center">{ProtectionTypeMap[contract.plan.protectionType]}</div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6} className="cell">
                      <div className="label">有効期間</div>
                      <div className="detailContent">
                        <div className="text center">
                          {fmtDate(contract.startedAt)} ~ {fmtDate(contract.endedAt)}
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={6} className="cell">
                      <div className="label">ステータス</div>
                      <div className="detailContent">
                        <div className="text center">{ContractStatusMap[contract.status]}</div>
                      </div>
                    </Col>
                  </Row>
                  {collapsedDetail ? (
                    <></>
                  ) : (
                    <>
                      <Row>
                        <Col xs={12} sm={6} className="cell">
                          <div className="label">ストア</div>
                          <div className="detailContent">
                            <div className="text center">
                              <a href={contract.store.webSite} target="_brank">
                                {contract.store.name}
                              </a>
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={6} className="cell">
                          <div className="label">保証プラン代金</div>
                          <div className="detailContent">
                            <div className="text center">¥{contract.plan.price}</div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} sm={6} className="cell">
                          <div className="label">商品購入日</div>
                          <div className="detailContent">
                            <div className="text center">{fmtDate(contract.transactionDate)}</div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}
                  <div>
                    {collapsedDetail ? (
                      <button className="collapsed-detail" onClick={onClickCollapsedDetailMore}>
                        View More
                      </button>
                    ) : (
                      <button className="collapsed-detail" onClick={onClickCollapsedDetailLess}>
                        View Less
                      </button>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
            {contract.status == 'Active' ? (
              <Col xs={12}>
                <div className="submit">
                  <a href={'/inquiry/chat/' + contract.id} target="_blank" className="btn-green" rel="noreferrer">
                    を申請する
                  </a>
                </div>
              </Col>
            ) : (
              <></>
            )}
          </Row>
          <Row className="box">
            <Col xs={12}>
              <Row>
                <Col>
                  <div className="section">ご契約者情報</div>
                </Col>
              </Row>
              <Row className="panel">
                <Col xs={12} sm={4} className="cell">
                  <img
                    src="/images/kkrn_icon_user_3.png"
                    alt="image"
                    className="miIcon"
                    onError={(e: any) => {
                      e.target.onError = null // 代替画像が取得できない場合の無限ループを回避
                      e.target.src = '/images/no_image.png'
                    }}
                  />
                  <div className="detailContent">
                    <div className="text">{contract.customer.name}</div>
                    <div className="text">{contract.customer.email}</div>
                  </div>
                </Col>
                <Col xs={12} sm={4} className="cell">
                  <img
                    src="/images/kkrn_icon_pin_4.png"
                    alt="image"
                    className="miIcon"
                    onError={(e: any) => {
                      e.target.onError = null // 代替画像が取得できない場合の無限ループを回避
                      e.target.src = '/images/no_image.png'
                    }}
                  />
                  <div className="detailContent">
                    <div className="text">{makePostalNumber(contract.customer.billingAddress)}</div>
                    <div className="text">{makeAddress(contract.customer.billingAddress)}</div>
                  </div>
                </Col>
                <Col xs={12} sm={4} className="cell">
                  <img
                    src="/images/kkrn_icon_denwa_3.png"
                    alt="image"
                    className="miIcon"
                    onError={(e: any) => {
                      e.target.onError = null // 代替画像が取得できない場合の無限ループを回避
                      e.target.src = '/images/no_image.png'
                    }}
                  />
                  <div className="detailContent">
                    <div className="text">{contract.customer.phone || '未登録'}</div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="box">
            <Col xs={12}>
              <Row>
                <Col>
                  <div className="section">お問い合わせ履歴</div>
                </Col>
              </Row>
              {!inquiries || inquiries.totalNumber === 0 ? (
                <Row>
                  <Col>お問い合わせが存在しません</Col>
                </Row>
              ) : (
                inquiries.inquiries?.map((inquiry, i) => (
                  <ListInquirySection
                    key={inquiry.id}
                    inquiry={inquiry}
                    collapsed={collapsedInquiry && i > 0}
                  ></ListInquirySection>
                ))
              )}

              {inquiries && collapsedInquiry && inquiries.totalNumber > 1 ? (
                <button className="collapsed" onClick={onClickCollapsed}>
                  View All
                </button>
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </Container>
      )}
    </div>
  )
}
